import {IntermediatePart} from "../../parts/intermediatePart";
import {BathTubType} from "../../constants";

export default class BathTubRim extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bathtub_rim';
    this.translateId = "visualizer.bathroom.bathtub.bathtub_rim";
    this.visible = [BathTubType.Custom60in];
    this.partName = 'Rim';
    this.dbName = "BathtubRim";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BathTubRim());
  }

  disabledClick() {
    if (this.disabled) {
      this.getParent().bathTubBase.disabled = true;
    } else {
      this.getParent().bathTubBase.disabled = false;
    }
  }

  handleClick() {
    const bathtubParent = this.getParent().getParent();
    bathtubParent.bathTubType_ = BathTubType.Custom60in;
    bathtubParent.activeSubType_ = BathTubType.Custom60in;
    super.handleClick();
  }

  setZIndex(zIndexes) {
    // if (layout.type === LayoutType.Large) {
    //     if (this.getParent().activeSubType() === BathTubType.Custom60in) {
    //         this.activeFeature.layer.zIndex = Z.layouts.Large.BathTub.Custom60in.Top;
    //     }
    // } else {
    //     Exception.NotImplemented();
    // }
    if (zIndexes && this.getParent().activeSubType() === BathTubType.Custom60in) {
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndexes.BathTub.Custom60in.Top;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.BathTub.Custom60in.Top;
      }
    }
  }

  setDefault(layout) {
    const filteredFeatures = this.features;
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Sahara Autumn  Porcelain Tile");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
    }
  }
}
